import {AnyAction} from 'redux'

export const tickets = (state: wix.events.ticketing.TicketDefinition[] = [], action: AnyAction) => {
  switch (action.type) {
    default:
      return state
  }
}
